module.exports = __webpack_public_path__ + "static/media/red-warning.d9f6837a.svg";